import { FORMS_INTEGRATION_TYPE, FORMS_SLOT_NODE_TYPE } from './consts';
/**
 * Every Wix Forms form id the document embeds through the slot plugin, including forms nested in
 * cards, layouts and tables. Accepts `null`/`undefined`, which is what a host holds before the
 * document loads.
 */
export const findFormSlotIds = (content) => {
    const ids = new Set();
    const walk = (nodes) => {
        nodes?.forEach((node) => {
            const slotData = node.type === FORMS_SLOT_NODE_TYPE ? node.slotData : undefined;
            if (slotData?.integrationType === FORMS_INTEGRATION_TYPE && slotData.resourceId) {
                ids.add(slotData.resourceId);
            }
            walk(node.nodes);
        });
    };
    walk(content?.nodes);
    return [...ids];
};
//# sourceMappingURL=find-form-slot-ids.js.map